import { render, staticRenderFns } from "./AutarkiegradCircle.vue?vue&type=template&id=57bc0819&scoped=true&"
import script from "./AutarkiegradCircle.vue?vue&type=script&lang=ts&"
export * from "./AutarkiegradCircle.vue?vue&type=script&lang=ts&"
import style0 from "./AutarkiegradCircle.vue?vue&type=style&index=0&id=57bc0819&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bc0819",
  null
  
)

export default component.exports